import Vue from 'vue'
import Router from 'vue-router'
// import HelloWorld from '@/components/HelloWorld'
import qrcode from '@/components/qrcodeRedirect'
// homepage
import home from '@/components/homepage/Home'
import aboutus from '@/components/homepage/Aboutuspage'
import download from '@/components/homepage/Download'
import policy from '@/components/homepage/Policy'
import contact from '@/components/homepage/Contact'
import login from '@/components/homepage/Login'
import register from '@/components/homepage/RegisterPhone'
import redirectservice from '@/components/homepage/RedirectService'
import checkconsent from '@/components/homepage/Check_consent'
import redirectfriend from '@/components/homepage/redirect_addfriend'
// layout chat
import layout from '@/components/chat/layout/Layout'
import LayoutChat from '@/components/chat/layout/LayoutChat'
import LayoutOnemeet from '@/components/chat/onemeet/LayoutOnemeet'
import ChatSideOnemeet from '@/components/chat/onemeet/ChatSideOnemeet'
import anonymousonegroup from '@/components/chat/layout/anonymousone_group'
// pagedefault
import HomepageChat from '@/components/chat/pagedefault/HomepageChat'
import NotFound from '@/components/chat/pagedefault/NotFound'
import NotPermission from '@/components/chat/pagedefault/NotPermission'
// settings
import SettingProfile from '@/components/chat/settings/EditProfile'
import Dropfile from '@/components/chat/settings/Dropfile'
import Feedback from '@/components/chat/settings/Feedback'
import Contact from '@/components/chat/settings/Contact'
import Policy from '@/components/chat/settings/Policy'
import Terms_of_service from '@/components/chat/settings/terms_of_service'
import Managefriend from '@/components/chat/settings/Managefriend'
// mobile layout
import LayoutMobile from '@/components/mobile/layout/LayoutMobile'
import LayoutChatMobile from '@/components/mobile/layout/LayoutChatMobile'
import LeftSideMobile from '@/components/mobile/layout/LeftSideMobileTest'
import RightSideMobile from '@/components/mobile/layout/RightSideMobile'
import RedirectChatRoom from '@/components/homepage/RedirectChatRoom'
import AddBot from '@/components/homepage/AddBot'
// mobile settings
import EditProfileMobile from '@/components/mobile/settings/Editprofile'
import FeedbackMobile from '@/components/mobile/settings/Feedback'
import ContactMobile from '@/components/mobile/settings/Contact'
import PolicyMobile from '@/components/mobile/settings/Policy'
import TermsofserviceMobile from '@/components/mobile/settings/TermsofService'
import SendfileMobile from '@/components/mobile/settings/Sendfileonebox'
import ManagefriendMobile from '@/components/mobile/settings/Managefriend'
import EditPhoneMobile from '@/components/mobile/settings/EditPhoneMo'
import AnonymousoneMobile from '@/components/mobile/settings/Anonymousone'
import LanguagesMobile from '@/components/mobile/settings/Languages'
// mobile mange
import Addfriend from '@/components/mobile/manage/Addfriend'
import Creategroup from '@/components/mobile/manage/Creategroup'
import Forward from '@/components/mobile/manage/Forwardmessage'
import Profilefriend from '@/components/mobile/manage/Profilefriend'
import Qrcodepage from '@/components/mobile/manage/Qrcodepage'
import Wallpaper from '@/components/mobile/manage/Wallpaper'
import ProgressLayout from '@/components/mobile/layout/ProgressLayout'

import redirecttest from '@/components/redirecttest'
import authen_callbackoneid from '@/components/authenCallbackOneid'
// test
import test from '@/components/test'
import test2 from '@/components/test2'
import test3 from '@/components/test3'

// tasks
import homepagetask from '@/components/chat/manage_task/homepage_task'
import homepageproject from '@/components/chat/manage_task/homepage_project'
import homepageallproject from '@/components/chat/manage_task/homepage_all_project'
import homepagecreateproject from '@/components/chat/manage_task/homepage_created_project'
import homepagecalendar from '@/components/chat/manage_task/homepage_calendar'
// tasks Mobile
import homepage_all_project_mobile from '@/components/mobile/task/homepage_all_project_mo'
import homepage_task_mobile from '@/components/mobile/task/homepage_task_mo'
import homepage_project_mobile from '@/components/mobile/task/homepage_project_mo'
import homepage_calendar_mobile from '@/components/mobile/task/homepage_calendar_mo'
import create_project_mobile from '@/components/mobile/task/create_project_page_mo'
// import TestLayoutMo from '@/components/mobile/layout/TestLayout'
//service
import homepageserviceMarket from '@/components/service/market'
// relation_friend with bot
import Relation from '@/components/homepage/Relation_login'
import Relation_friend from '@/components/homepage/Relation_friend'
//conference
import Layout_conference from '@/components/conference/layoutConference'
// agora_call
import AgroraCall from '@/components/chat/agora_call/video_call_v3'
import AgroraCall_test from '@/components/chat/agora_call/video_call_v4'
// import AgroraTestCall from '@/components/chat/agora_call/test_call'
// redirect url to chatroom
import RedirectUrlRoom from '@/components/homepage/RedirectUrlRoom'
import RedirectRoomWithUrl from '@/components/RedirectRoomWithUrl'
import RedirectRoomWithSharedToken from '@/components/RedirectRoomWithSharedToken'
import custsat from '@/components/custsat/custsat'
import consent from '@/components/consent/consent'
import consent_1 from '@/components/consent/consent_C7gi50r08q6'
// login with sharetoken
import LoginWithSharedToken from '@/components/LoginWithSharedToken'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  routes: [
    { path: '/', component: home },
    { path: '/custsat', component: custsat },
    { path: '/homepage', component: home },
    { path: '/test', component: test },
    { path: '/test2', component: test2 },
    { path: '/test3', component: test3 },
    { path: '/redirect', component: redirecttest },
    { path: '/authorization/redirect', component: authen_callbackoneid },
    { path: '/login', component: login, meta: {requiresHome: true}},
    { path: '/login-with-shared-token', component: LoginWithSharedToken },
    { path: '/download', component: download },
    { path: '/register', component: register },
    { path: '/about', component: aboutus },
    { path: '/policy', component: policy },
    { path: '/contactus', component: contact },
    { path: '/qrcode/:type', component: qrcode },
    { path: '/redirect-addfriend', component: redirectfriend },
    { path: '/service/:type', component: qrcode },
    { path: '/not_found', component: NotFound },
    { path: '/redirect_service/:serviceinfor', component: redirectservice },
    { path: '/check-consent/:tokenroom', component: checkconsent },
    { path: '/relation', component: Relation },
    { path: '/relation/friend', component: Relation_friend },
    { path: '/redirect/chatroom/:botid', component: RedirectChatRoom },
    { path: '/redirect-room', component: RedirectUrlRoom },
    { path: '/weburl-go-room', component: RedirectRoomWithUrl },
    { path: '/redirect-room-sharetoken', component: RedirectRoomWithSharedToken },
    { path: '/addbot/:botid', component: AddBot },
    { path: '/conference/auth',
      component: Layout_conference,
      // children: []
    },
    { path: '/chat/room/call/:typecall', component: AgroraCall },
    { path: '/chat/room/testcall/:typecall', component: AgroraCall_test },
    // { path: '/chat/room/call/:typecall/:roomid', component: AgroraCall },
    // { path: '/chat/room/test/call/:roomid', component: AgroraTestCall },
    { path: '/chat',
      component: layout,
      children: [
        { path: '/anonymousone_group', component: anonymousonegroup },
        { path: '/chat', component: HomepageChat},
        { path: '/chat/not_found', component: NotFound},
        { path: '/chat/not_permission', component: NotPermission },
        { path: '/chat/room/:roomid', component: LayoutChat },
        { path: '/chat/settings/profile', component: SettingProfile },
        { path: '/chat/settings/uploadfile/onebox', component: Dropfile },
        { path: '/chat/settings/feedback', component: Feedback },
        { path: '/chat/settings/support', component: Contact },
        { path: '/chat/settings/policy', component: Policy },
        { path: '/chat/settings/terms_of_service', component: Terms_of_service},
        { path: '/chat/settings/managefriend', component: Managefriend },
        { path: '/chat/task/:projectid/:roomid', component: homepagetask },
        { path: '/chat/room/project/:roomid', component: homepageproject },
        { path: '/chat/project/all_project', component: homepageallproject },
        { path: '/chat/project/create_project', component: homepagecreateproject },
        { path: '/chat/project/calendar', component: homepagecalendar },
        { path: '/chat/service/market', component: homepageserviceMarket },
        { path: '/onemeeting', component: LayoutOnemeet },
        { path: '/onemeet/chat/:roomid', component: ChatSideOnemeet },
      ],
      meta: {requiresLogin: true}
    },
    { path: '/layoutmobile',
      component: LayoutMobile,
      children: [
        { path: '/mobile/homepage', component: LeftSideMobile },
        { path: '/mobile/room/:roomid', component: LayoutChatMobile },
        { path: '/mobile/room/infor/:roomid', component: RightSideMobile },
        { path: '/mobile/settings/profile', component: EditProfileMobile },
        { path: '/mobile/settings/profile/editphone', component: EditPhoneMobile },
        { path: '/mobile/settings/feedback', component: FeedbackMobile },
        { path: '/mobile/settings/support', component: ContactMobile },
        { path: '/mobile/settings/policy', component: PolicyMobile },
        { path: '/mobile/settings/terms_of_service', component: TermsofserviceMobile },
        { path: '/mobile/settings/uploadfile/onebox', component: SendfileMobile },
        { path: '/mobile/settings/managefriend', component: ManagefriendMobile },
        { path: '/mobile/settings/anonymousone_group', component: AnonymousoneMobile },
        { path: '/mobile/settings/languages', component: LanguagesMobile },
        { path: '/mobile/addfriend', component: Addfriend },
        { path: '/mobile/creategroup', component: Creategroup },
        { path: '/mobile/forward/:roomid', component: Forward },
        { path: '/mobile/profilefriend/:profileid', component: Profilefriend },
        { path: '/mobile/qrcode', component: Qrcodepage },
        { path: '/mobile/task/project', component: homepage_all_project_mobile },
        { path: '/mobile/task/:projectid/:roomid', component: homepage_task_mobile },
        { path: '/mobile/room/project/:roomid', component: homepage_project_mobile },
        { path: '/mobile/task/calendar', component: homepage_calendar_mobile },
        { path: '/mobile/task/createproject', component: create_project_mobile },
        { path: '/mobile/wallpaper/:roomid', component: Wallpaper },
        { path: '/mobile/progress/:roomid', component: ProgressLayout }
        // { path: '/mobile/testlayout', component: TestLayoutMo }
      ],
      meta: { requiresLogin: true }
    },
    {
      path: '/consent',
      component: consent,
      children: [
        { path: 'C7gi50r08q6', component: consent_1 }
      ],
      // meta: {requiresLogin: true}
    },
    { path: '*', redirect: '/' }
  ]
})

router.beforeEach((to, from, next) => {
  if (to.matched.some((x) => x.meta.requiresLogin)) {
      if (localStorage.getItem('Authenrization') == undefined) {
        next({ path: '/login' })
      } else {
        next()
      }
    return
  } else if (to.matched.some((x) => x.meta.requiresHome)) {
      if (localStorage.getItem('Authenrization') == undefined) {
        next()
      } else {
        next({ path: '/chat/homepage' })
      }
    return
  }
  next()
})
export default router



// WEBPACK FOOTER //
// ./src/router/index.js